import { render, staticRenderFns } from "./surname.vue?vue&type=template&id=297d9b8e"
import script from "./surname.vue?vue&type=script&lang=js"
export * from "./surname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports